import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MsalService } from './msal.service';

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(private adalService: MsalService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const authenticated = await this.adalService.isAuthenticated();
    if (authenticated) {
      return true;
    } else {
      this.adalService.login(state.url);
      return false;
    }
  }
}
